import { useState, useRef, useEffect } from 'react';

const faqs = [
  {
    q: '韩国漫画和无删减漫画有什么区别？',
    a: '韩国漫画原版通常包含完整的故事情节和画面细节，而无删减版本保留了原版漫画的所有内容，包括可能被删节的感情线、剧情转折和画面细节。我们平台提供的韩国漫画均为无删减版本，确保您获得最完整的阅读体验。',
  },
  {
    q: '什么是下拉式韩漫阅读方式？',
    a: '下拉式阅读是韩国漫画（Webtoon）的特色阅读方式，区别于传统日漫的翻页模式。您可以像浏览网页一样，通过向下滚动屏幕来连续阅读漫画内容。这种方式更适合手机和电脑屏幕，让阅读更加流畅自然，无需频繁翻页。',
  },
  {
    q: '韩漫网站的漫画资源是否真的免费？',
    a: '是的！我们韩漫网站致力于打造免费韩漫大全平台，所有漫画资源均免费提供阅读。我们通过社区支持和平台运营来维持服务，不向读者收取任何费用。我们希望让每一位喜爱韩国漫画的读者都能无负担地享受阅读乐趣。',
  },
  {
    q: '平台上的漫画多久更新一次？',
    a: '我们与韩国漫画原作者和出版社保持密切合作，确保漫画更新同步。大部分连载中的韩国漫画每周更新一话，热门作品可能会更频繁。您可以关注"最新更新"栏目，随时了解每日更新的漫画动态。',
  },
  {
    q: '为什么选择下拉式韩国漫画而非传统翻页漫画？',
    a: '下拉式格式是韩国网漫（Webtoon）的核心特色。它专为数字屏幕设计，通过纵向排布让画面之间的过渡更加流畅，给予读者更强的沉浸感。同时，下拉式漫画对移动设备特别友好，无论在手机还是平板上阅读，都能获得极佳的体验。',
  },
  {
    q: '韩漫网站支持哪些设备阅读？',
    a: '我们的平台采用响应式设计，完美支持手机、平板和电脑端阅读。无论您使用什么设备，都能获得流畅的下拉式韩国漫画阅读体验。在手机上阅读时，单栏纵向布局让每一话都清晰呈现；在电脑端，大屏幕带来更震撼的视觉效果。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    contentRefs.current = contentRefs.current.slice(0, faqs.length);
  }, []);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于韩国漫画下拉式阅读的常见疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                ref={(el) => { contentRefs.current[index] = el; }}
                className="transition-all duration-300 overflow-hidden"
                style={{
                  maxHeight: openIndex === index ? '300px' : '0px',
                }}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}